import {BACKEND} from '../../consts/backend';
import {apiKey} from './keys.helper';

const DeleteDocument = async (po) => {
  var requestOptions = {
    method: 'POST',
    redirect: 'follow',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: apiKey,
    },
    body: JSON.stringify(po),
  };

  const resp = await fetch(
    `${BACKEND}/expo/remove-documents`,
    requestOptions
  ).catch((err) => err);

  const sku = await resp;
  return sku;
};

export default DeleteDocument;
